import template from './operative-spending.html';
import controller from './operative-spending.controller';

let operativeSpendingComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default operativeSpendingComponent;
